// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2W2is","spinner":"Loader_spinner__1izTB"};